import { Player } from '../entities/Player.ts';
import { Item } from '../entities/Item.ts';

export class CollisionSystem {
  public static checkCatch(player: Player, item: Item): boolean {
    if (item.isCaught) return false;

    // Platter top rim Y coordinate and thickness
    const trayTop = player.y - player.height * 0.45;
    const trayBottom = player.y + player.height * 0.70;

    // Swept vertical check (from previous position to current position)
    const prevBottom = item.prevY + item.bottomOffset;
    const currentBottom = item.y + item.bottomOffset;

    // Check if the item crossed or is within the tray vertical zone in this frame
    const crossedTray = (prevBottom <= trayBottom && currentBottom >= trayTop) ||
                        (currentBottom >= trayTop && item.y <= trayBottom);

    if (crossedTray) {
      // Check horizontal boundary (curved elliptical tolerance)
      const halfWidth = player.width * 0.54;
      const dx = Math.abs(item.x - player.x);

      if (dx <= halfWidth) {
        return true;
      }
    }

    return false;
  }
}
